import { cn } from '@/platform/lib/utils';
import { Tab as HeadlessTab } from '@headlessui/react';

const Tab = ({ className, children, ...props }) => (
    <HeadlessTab
        className={cn(
            '-mb-px inline-flex items-center gap-x-2 border-b-2 border-transparent px-1 py-3 text-sm/6 font-medium whitespace-nowrap text-gray-500 transition-colors',
            'hover:border-gray-300 hover:text-gray-700',
            'data-selected:border-primary-600 data-selected:text-primary-600',
            'focus:outline-hidden',
            'data-disabled:pointer-events-none data-disabled:opacity-50',
            className
        )}
        {...props}
    >
        {children}
    </HeadlessTab>
);

export default Tab;
